<template>
  <div class="viewurl-detail">

    <el-breadcrumb style="margin-bottom:30px; margin-top:25px;" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="first-breadcrumb">{{ $t("SidebarMenu.Menu06") }}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/SPU/PriceMonitoring/' + $route.params.Id }">{{ defalutbrand }}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="$route.name == 'SPUViewUrlDetail'" :to="{ path: '/SPU/PriceMonitoring/' + $route.params.Id + '/' + $route.params.SkuId }">{{topinfo.name}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="$route.name == 'SPUViewUrlDetail1'" :to="{ path: '/SPU/PriceMonitoring/' + $route.params.Id + '/LowPriced' }">{{ $t('jgjk.s999') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ urlName }}</el-breadcrumb-item>
    </el-breadcrumb>    
    <div class="static-page-line"></div>
    
    <ViewUrlDetailTable />
  </div>
</template>

<script>
import ViewUrlDetailTable from '@/components/SPU/PriceMonitoring/ViewUrlDetailTable.vue'
export default {
  components: {
    ViewUrlDetailTable
  },
  data(){
    return{
      urlName: JSON.parse(localStorage.getItem("SPUviewurlDetail")).val,
      linechartdata24hs: {},
      linechartdatatrend: {},
      linechartdatatrendtitle: '',
      topinfo:{
        name: '',
        series: '',
        model: '',
        type: '',
        channel: ''
      },
      defalutbrand: ''
    }
  },

  mounted(){
    this.getPricemonitoring()
    this.getTopInfo()
  },

  methods: {

    /**
     * 获取品牌
     */
    getPricemonitoring: function(){
      let that = this
      let priceArr = JSON.parse(localStorage.getItem("price")).val
      for(let i=0; i<priceArr.length; i++){
        if(priceArr[i].subid/1 === that.$route.params.Id/1){
          that.defalutbrand = priceArr[i].name
        }
      }
    },
    /**
     * 获取总览信息
     */
    getTopInfo: function(){
      let skuinfo = JSON.parse(localStorage.getItem("viewurl")).val
      let info = {
        name: skuinfo.name,
        series: skuinfo.series,
        model: skuinfo.model,
        type: skuinfo.type,
        channel: skuinfo.channel        
      }
      this.topinfo = info
    },

  }
}
</script>
